import React, { ReactElement } from 'react'

export default function Footer(): ReactElement {
  return (
    <footer>
      &copy; 2024, created by
      <a href="https://rekovar.com" target="_blank" rel="noopener noreferrer">
        {' '}
        Rekovar
      </a>
    </footer>
  )
}
